import PropTypes from 'prop-types';

export const OptionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});

const OptionsListShape = PropTypes.arrayOf(OptionShape);

export const SelectOptionsShape = PropTypes.oneOfType([
  OptionsListShape,
  PropTypes.shape({
    label: PropTypes.string,
    options: OptionsListShape,
  }),
]);

export const AttributeSuggestionsShape = PropTypes.objectOf(
  PropTypes.arrayOf(PropTypes.string)
);
